export const tsUrl = (ts) => {

    const arrayTSLink = ts.split('#EXTINF:3.0,')
    
    return arrayTSLink[1].replace('\n', '')
}